import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import { Form, Row, Col, Button } from "react-bootstrap";
import { fetchCurrency } from "../Api/InvoiceApi";
// EditCustomer - React component updated to use react-bootstrap's
// <Form>, <Row>, <Col>, <Form.Group> and <Form.Select>. A pencil icon
// is added to the header which focuses the Name input for quick edit.
// Make sure you have react-bootstrap installed: `npm i react-bootstrap bootstrap`.

export default function EditCustomer() {
  const { customerCode } = useParams();
  const navigate = useNavigate();
  const { token, authTokens, user } = useAuth() || {};

  const nameRef = useRef(null);

  // derive an access token from common shapes of useAuth
  const accessToken =
    token ||
    authTokens?.accessToken ||
    authTokens?.token ||
    authTokens?.access ||
    user?.token ||
    null;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
const [currencyList, setCurrencyList] = useState([]);
const [loadingCurrency, setLoadingCurrency] = useState(false);

  // form state for editable fields
  const [form, setForm] = useState({
    name: "",
    mobileNumber: "",
    creditLimit: "",
    address1: "",
    address2: "",
    address3: "",
    active: "Yes",
    pincode: "",
    pan:"",
    gst:"",
    currencyCode: "",
  });
  useEffect(() => {
  setLoadingCurrency(true);
  fetchCurrency()
    .then((res) => {
      setCurrencyList(res || []);
    })
    .catch(() => {
      setCurrencyList([]);
    })
    .finally(() => setLoadingCurrency(false));
}, []);

  // fetch customer on mount / customerCode change
  useEffect(() => {
    if (!customerCode) return;
    setLoading(true);
    setError(null);

    const url = `${Base_URL}/CustomerMaster/CustomerByCode/id?id=${customerCode}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
      })
      .then((res) => {
        const data = res.data || {};
        setForm({
          name: data.name || "",
          mobileNumber: data.mobileNumber || data.mobile || "",
          creditLimit:
            data.creditLimit != null ? String(data.creditLimit) : "",
          address1: data.address1 || "",
          address2: data.address2 || "",
          address3: data.address3 || "",
          active: data.active || "Yes",
          pincode: data.pincode || data.pinCode || "",
          pan: data.pan || "",
          gst: data.gstno ||data.taxId,
          currencyCode: data.currencyCode || "",
        });
      })
      .catch((err) => {
        const msg =
          err?.response?.data || err?.response?.data?.message || err.message;
        setError(String(msg));
      })
      .finally(() => setLoading(false));
  }, [customerCode, accessToken]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  }

  function validate() {
    const errors = [];
    if (!form.name.trim()) errors.push("Name is required.");
 
    if (form.creditLimit && isNaN(Number(form.creditLimit)))
      errors.push("Credit limit must be a number.");
    // if (form.pincode && !/^\\d{4,10}$/.test(form.pincode))
    //   errors.push("Pincode should be 4-10 digits.");
    return errors;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errors = validate();
    if (errors.length) {
      setError(errors.join(" "));
      return;
    }

    setSaving(true);
    setError(null);

    // Prepare payload: include fields expected by backend; here we update only the editable ones
    const payload = {
      // include customerCode so server can identify record if required
      customerCode: customerCode,
      name: form.name,
      mobileNumber: form.mobileNumber,
      creditLimit: form.creditLimit === "" ? null : Number(form.creditLimit),
      address1: form.address1,
      address2: form.address2,
      address3: form.address3,
      active: form.active,
      pincode: form.pincode,
      pan:form.pan,
      gst:form.gst,
      currencyCode: form.currencyCode,
    };

    // If your backend expects a dedicated update endpoint, change this URL accordingly.
    const updateUrl = `${Base_URL}/CustomerMaster/UpdateCustomerByCode`;

    try {
      await axios.put(updateUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
      });

      // success -> navigate back
      navigate(-1);
    } catch (err) {
      const msg =
        err?.response?.data || err?.response?.data?.message || err.message;
      setError(String(msg));
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="p-4">Loading customer...</div>;

  return (
    <div className="max-w-3xl mx-auto p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">Edit Customer - {customerCode}</h1>

        {/* Pencil icon button - focuses name field */}
       
      </div>

      {error && (
        <div className="mb-4 p-3 rounded bg-red-50 text-red-700">{error}</div>
      )}

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={12}>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                ref={nameRef}
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Customer name"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group controlId="mobileNumber">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                name="mobileNumber"
                value={form.mobileNumber}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="7007696900"
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="creditLimit">
              <Form.Label>Credit Limit</Form.Label>
              <Form.Control
                name="creditLimit"
                value={form.creditLimit}
                onChange={handleChange}
                inputMode="decimal"
                placeholder="0"
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group controlId="active">
              <Form.Label>Active</Form.Label>
              <Form.Select
                name="active"
                value={form.active}
                onChange={handleChange}
              >
                <option>Yes</option>
                <option>No</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="address1">
              <Form.Label>Address 1</Form.Label>
              <Form.Control
                name="address1"
                value={form.address1}
                onChange={handleChange}
                placeholder="Nehru Road"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="address2">
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                name="address2"
                value={form.address2}
                onChange={handleChange}
                placeholder="Farrukhabad"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="address3">
              <Form.Label>Address 3</Form.Label>
              <Form.Control
                name="address3"
                value={form.address3}
                onChange={handleChange}
                placeholder="Uttar Pradesh"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="pincode">
              <Form.Label>Pincode</Form.Label>
              <Form.Control
                name="pincode"
                value={form.pincode}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="209625"
              />
            </Form.Group>
          </Col>
        </Row>
          <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="address3">
              <Form.Label>PAN</Form.Label>
              <Form.Control
                name="pan"
                value={form.pan}
                onChange={handleChange}
                placeholder="Uttar Pradesh"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="pincode">
              <Form.Label>GST</Form.Label>
              <Form.Control
                name="gst"
                value={form.gst}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="209625"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
  <Col md={6}>
    <Form.Group controlId="currencyCode">
      <Form.Label>
        Currency Code <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        name="currencyCode"
        value={form.currencyCode}
        onChange={handleChange}
        required
        disabled={loadingCurrency}
      >
        <option value="">Select Currency</option>
        {currencyList.map((currency) => (
          <option
            key={currency.currencyCode}
            value={currency.currencyCode}
          >
            {currency.currencyCode} - {currency.currencyName}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>
</Row>

        <div className="d-flex gap-2">
          <Button type="submit" disabled={saving} variant="primary">
            {saving ? "Saving..." : "Save"}
          </Button>

          <Button variant="light" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
